<form [formGroup]="editFormGroup">
  <div class="ps-flex-container-col">
    <mat-error>
    <span *ngIf="editFormGroup?.errors?.mismatchedCount">
     {{'orders.overlays.createPlannedDelivery.mismatchedCount' | translate}}
    </span>
    </mat-error>

    <mat-form-field appearance="fill">
      <mat-label>{{'orders.overlays.createPlannedDelivery.plannedNrOfPieces' | translate}}</mat-label>
      <input matInput type="text" formControlName="plannedCount">
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>{{'orders.overlays.createPlannedDelivery.plannedDeliveryDate' | translate}}</mat-label>
      <input matInput [matDatepicker]="picker" formControlName="plannedDate">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>{{'orders.overlays.createPlannedDelivery.deliveryComment' | translate}}</mat-label>
      <input matInput type="text" formControlName="deliveryComment">
    </mat-form-field>

    <mat-form-field appearance="fill" *ngIf="isQsDelivery()">
      <mat-label>{{'orders.overlays.createPlannedDelivery.incident' | translate}}</mat-label>
      <mat-select formControlName="deliveryIncident" [compareWith]="compareIncidents">
        <mat-option *ngFor="let incident of incidents$ | async" [value]="incident">
          {{incident.TEXT}} <span
          style="color: red">({{incident.PARTS_AFFECTED}} {{'orders.overlays.createPlannedDelivery.partsAffected' | translate}}
          )</span>
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div>
      <button mat-button color="primary" (click)="save()" [disabled]="!editFormGroup.valid">
        {{'orders.overlays.createPlannedDelivery.save' | translate}}
      </button>
      <button mat-button color="primary" (click)="dismiss()">
        {{'orders.overlays.createPlannedDelivery.cancel' | translate}}
      </button>
    </div>
  </div>
</form>

